import { makeAutoObservable } from 'mobx';
import { initialErrors, initialState } from '~/consts/standAdmin';
import { InputChangeState, InputErrorState } from '~/definitions/standAdmin';
import onSubmit from '~/mobx/StandAdminStore/fn/onSubmit';

export default class StandAdminStore {
    inputChangeState: InputChangeState = initialState;
    inputErrors: InputErrorState = initialErrors;
    sid: string = '';
    standAdminRedirectUrl: string = '';

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.inputChangeState = initialState;
        this.inputErrors = initialErrors;
        this.sid = '';
    }

    setSid = (sid: string) => {
        this.sid = sid;
    };

    setStandAdminRedirectUrl = (url: string) => {
        this.standAdminRedirectUrl = url;
    };

    onInputChange = (updates: Partial<InputChangeState>) => {
        this.inputChangeState = { ...this.inputChangeState, ...updates };

        // Clear error for the updated fields
        Object.keys(updates).forEach((key) => {
            if (key in this.inputErrors) {
                this.inputErrors[key as keyof InputErrorState] = false;
            }
        });
    };

    isSubmitDisabled = () => {
        return this.inputChangeState.coopId === '' || this.inputChangeState.birthdate === '';
    };

    onSubmit = onSubmit;
}
